declare const window: any;
import Highcharts from "highcharts";

interface NumberSeparatorResult {
    decimal: string;
    thousand: string;
}

export class FormatHelpers {
    static numberToString(value: number, decimalPlaces?: number): string {
        if (isNaN(decimalPlaces) || decimalPlaces < 0) {
            decimalPlaces = 2;
        }

        const decimalSep = window.decimalSeparator;
        const thousandSep = window.thousandSeparator;

        if (decimalSep && thousandSep) {
            if (Math.abs(value) >= 1000000000000) {
                return Highcharts.numberFormat(value / 1000000000, decimalPlaces, decimalSep, thousandSep) + "T";
            } else if (Math.abs(value) >= 1000000000) {
                return Highcharts.numberFormat(value / 1000000000, decimalPlaces, decimalSep, thousandSep) + "B";
            } else if (Math.abs(value) >= 1000000) {
                return Highcharts.numberFormat(value / 1000000, decimalPlaces, decimalSep, thousandSep) + "M";
            } else if (Math.abs(value) >= 1000) {
                return Highcharts.numberFormat(value / 1000, decimalPlaces, decimalSep, thousandSep) + "K";
            }
            
            return Highcharts.numberFormat(value, decimalPlaces, decimalSep, thousandSep);
        } else {
            if (Math.abs(value) >= 1000000000000) {
                return Highcharts.numberFormat(value / 1000000000000, decimalPlaces) + "T";
            } else if (Math.abs(value) >= 1000000000) {
                return Highcharts.numberFormat(value / 1000000000, decimalPlaces) + "B";
            } else if (Math.abs(value) >= 1000000) {
                return Highcharts.numberFormat(value / 1000000, decimalPlaces) + "M";
            } else if (Math.abs(value) >= 1000) {
                return Highcharts.numberFormat(value / 1000, decimalPlaces) + "K";
            }
            
            return Highcharts.numberFormat(value, decimalPlaces);
        }
    }
    
    static numberToStringThousandSeparators(value: number, addDecimalPlacesIfNeeded: boolean, decimalPlaces?: number) {
        if (isNaN(decimalPlaces) || decimalPlaces < 0) {
            decimalPlaces = 2;
            if (value != 0 && value < 1) {
                decimalPlaces = 4;
            }
        }

        if (addDecimalPlacesIfNeeded && value % 1 === 0) {
            decimalPlaces = 0;
        }
        
        const decimalSep = window.decimalSeparator;
        const thousandSep = window.thousandSeparator;
        if (decimalSep && thousandSep) {
            return Highcharts.numberFormat(value, decimalPlaces, decimalSep, thousandSep);
        } else {
            return Highcharts.numberFormat(value, decimalPlaces);
        }
    }

    static getNumberSeparators(): NumberSeparatorResult {
        // default
        const res = {
          decimal: ".",
          thousand: ","
        };
        
        // convert a number formatted according to locale
        const str = parseFloat('1234.56').toLocaleString();
        
        // if the resulting number does not contain previous number
        // (i.e. in some Arabic formats), return defaults
        if (!str.match("1"))
          return res;
        
        // get decimal and thousand separators
        res.decimal = str.replace(/.*4(.*)5.*/, "$1");
        res.thousand = str.replace(/.*1(.*)2.*/, "$1");
        
        // return results
        return res;
    }
}